<template>
  <div
    class="card"
    :class="[{'editing' : editing }, {'has-status' : card.status}, {'has-token' : card.token}]"
  >
    <template v-if="card.status">
      <div class="icon icon-drag-handle" />

      <div
        class="card__status-indicator status-indicator"
        :class="`card__status-indicator--${card.status}`"
      />
    </template>

    <div class="card-info">
      <!-- Read View -->
      <template v-if="!editing">
        <div class="card-title">
          {{card.title}}

          <button
            class="tb-btn tb-btn-text sm"
            title="Edit production title"
            @click.stop.prevent="openEditing"
          >
            <span class="fas fa-pencil" />
          </button>
        </div>

        <div
          v-if="card.production && !hideProductionTitle"
          class="card-subtitle text-xs"
          :title="card.production.title"
        >
          {{card.production.title}}
        </div>

        <div
          v-if="type === 'production'"
          class="card-subtitle text-xs"
        >
          Created {{ card.created_time | timestamp }}
        </div>
      </template>

      <!-- Edit View -->
      <template v-else>
        <form @submit.prevent="save">
          <input class="tb-input" ref="title" type="text" v-model="title" placeholder="Production title">
          <button type="submit" class="hidden"></button>
        </form>
      </template>
    </div>

    <div class="card-actions" v-if="!editing">
      <router-link
        v-if="type === 'production'"
        :to="{ name: 'production', params: { production_id: card._id }}"
        class="tb-btn tb-btn-text high-em"
      >
        Launch
      </router-link>

      <router-link
        v-if="type === 'composer'"
        :to="{ name: 'production', params: { production_id: card._id }}"
        class="tb-btn tb-btn-text high-em"
      >
        Launch
      </router-link>

      <button
        v-if="type === 'screen' && card.status === 'connected'"
        title="Force reload output"
        class="tb-btn tb-btn-text medium-em"
        @click="$emit('reload')"
      >
        <i class="fas fa-sync"></i>
      </button>

      <copy-clipboard
        v-if="card.token"
        title="Copy display URL"
        class="tb-btn tb-btn-text medium-em"
        :data-clipboard-text="screenUrl"
      >
        <i class="fas fa-link"></i>
      </copy-clipboard>

      <a
        href="#"
        class="tb-btn tb-btn-text medium-em"
        title="Delete"
        @click.stop.prevent="$emit('delete', card)"
      >
        <i class="fas fa-trash"></i>
      </a>

      <a
        v-if="showCopyButton"
        href="#"
        class="tb-btn tb-btn-text medium-em"
        title="Duplicate production"
        v-on:click.stop.prevent="$emit('duplicate', card)"
        data-balloon="Duplicate production"
        data-balloon-pos="up"
      >
        <i class="icon icon-copy"></i>
      </a>
    </div>

    <div class="card-actions margin-left-xxs" v-if="editing">
      <button
        title="Save"
        class="tb-btn tb-btn-text medium-em"
        @click.prevent="save"
      >
        <span class="icon icon-checkmark"></span>
      </button>

      <button
        title="Cancel"
        class="tb-btn tb-btn-text medium-em"
        @click.prevent="cancel"
      >
        <span class="icon icon-cross"></span>
      </button>
    </div>
  </div>
</template>

<script>
import CopyClipboard from '../../shared/copy-clipboard/CopyClipboard.vue';

// TODO: This component is a mess and not at all generic.
// We should either split it out into separate components for producer, composer, and screens,
// or update it to actually be generic

export default {
  props: {
    card: {
      type: Object,
      required: true,
    },

    type: {
      type: String,
      required: true,
    },

    hideProductionTitle: {
      type: Boolean,
      default: false,
    },

    showCopyButton: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    'copy-clipboard': CopyClipboard,
  },

  data() {
    return {
      editing: false,
      title: this.card.title,
    };
  },

  computed: {
    screenUrl() {
      return `${process.env.LIVE_URL}/#/${this.card.token}`;
    },
  },

  methods: {
    openEditing() {
      this.editing = true;

      this.$nextTick(() => {
        this.$refs.title.focus();
      });
    },

    save() {
      this.card.title = this.title;
      this.$emit('save', this.card);
      this.editing = false;
    },

    cancel() {
      this.editing = false;
      this.title = this.card.title;
    },
  },
};
</script>

<style lang="scss" scoped>
.card__status-indicator {
  width: 8px;
  height: 8px;
  border-radius: 100%;
  background-color: #00D483;

  &--disconnected {
    background-color: #e65447;
  }
}
</style>
